// 创建axios实例
import axios from "axios";
import QS from "qs";
import { Loading, Message } from "element-ui";
import { getStore, setStore } from "@/units/store";
import store from '@/store'
import { baseUrl } from '@/units/config';
axios.defaults.baseURL = baseUrl;

const service = axios.create({
  timeout: 30000 // 请求超时时间
  // transformRequest: data => qs.stringify(data)
});
let loading = null;
// 添加请求拦截器
service.interceptors.request.use(
  function(config) {
    loading = Loading.service({
      text: "",
      spinner: "el-icon-loading",
      background: "rgba(0,0,0,0)"
    });

    // 平台
    config.headers['platform'] = 'H5';
    config.headers["token"] = store.getters.token || ''
    config.headers['tenant-id'] = store.getters.tenant_id || ''

    axios.defaults.headers["accept"] = "*/*";
    axios.defaults.headers["contentType"] = "application/x-www-form-urlencoded";
    // 在发送请求之前做些什么
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    console.log("ajaxError");
    return Promise.reject(error);
  }
);
// 添加响应拦截器
service.interceptors.response.use(
  response => {
    // 自动设置登陆令牌
    if (response.headers.token) {
      store.commit('user/SET_TOKEN', response.headers.token)
    }

    // 对响应数据做点什么
    let data = {
      code: response.data.code,
      data: response.data.data
    };

    loading.close();
    if (response.data.code != 1) {
      Message.error(response.data.msg);
      if (response.data && response.data.code == 401) {
        setTimeout(res => {
          store.commit('user/CLEAR_TOKEN');
          location.href = "/login";
        }, 3000);
      }
      return Promise.reject(response.data);
    } else {
      // Message({
      //   message: response.data.msg,
      //   type: "success"
      // });
    }
    return data;
  },
  (error) => {
    Message({
      message: error.response.data.msg,
      type: "error"
    });

    if (error.response.data && error.response.data.code == 401) {
      setTimeout(res => {
        store.commit('user/CLEAR_TOKEN');
        location.href = "/login";
      }, 3000);
    }

    // setTimeout(res => {
    //   localStorage.removeItem("userInfo");
    //   location.href = "/login";
    // }, 3000);
    return Promise.reject(error);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Object} loading [是否显示Loading与Toast,{isLoading: true,isToast: false}]
 */
export function get(
  url,
  params,
  loading = {
    isLoading: true,
    isToast: false
  }
) {
  return new Promise((resolve, reject) => {

    console.log('params === ',params)
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Object} loading [是否显示Loading与Toast,{isLoading: true,isToast: false}]
 */
export function post(
  url,
  params,
  loading = {
    isLoading: true,
    isToast: false
  }
) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
// 最后暴露实例
export default service;



// WEBPACK FOOTER //
// ./src/units/https.js